import cn from 'classnames'
import * as React from 'react'
import { Icon } from '../icon'
import Typography from '../typography/Typography'
import styles from './Step.module.css'
import { StepProps, TimelineStepPosition, TimelineStepState } from './VerticalTimeline.types'

export function Step({ position, state, title, overline, text, children, className, role = 'listitem', ...rest }: StepProps) {
  const isCurrent = state === TimelineStepState.Current
  const isCompleted = state === TimelineStepState.Completed
  const isActive = isCurrent || isCompleted

  const isTopTrackVisible = position !== TimelineStepPosition.First
  const isBottomTrackVisible = position !== TimelineStepPosition.Last

  return (
    <div className={cn(styles.step, className)} role={role} {...rest}>
      <div className={styles.markerColumn}>
        {isTopTrackVisible && (
          <div className={cn(styles.track, styles.trackTop, isActive && styles.trackActive)} />
        )}
        <div className={cn(styles.marker, isActive && styles.markerActive)}>
          {isCurrent && <Icon glyph="CircleFilledExtraSmall" size={14} className={styles.markerIcon} />}
          {isCompleted && <Icon glyph="CheckMarkExtraSmall" size={14} className={styles.markerIcon} />}
        </div>
        {isBottomTrackVisible && (
          <div className={cn(styles.track, styles.trackBottom, isCompleted && styles.trackActive)} />
        )}
      </div>
      <div className={cn(styles.content, !isBottomTrackVisible && styles.contentLast)}>
        <Typography variant="body-m-bold-tight" className={styles.title}>{title}</Typography>
        {overline && <Typography variant="body-s-regular-tight" className={styles.overline}>{overline}</Typography>}
        {children ?? (text && <Typography variant="body-m-regular-snug" className={styles.text}>{text}</Typography>)}
      </div>
    </div>
  )
}
